module.exports = __webpack_public_path__ + "img/141.6.d92c104e.png";